module.exports = __webpack_public_path__ + "static/media/mineraçao-img3.5c32378a.jpg";